var render, staticRenderFns
import script from "./UiTab.vue?vue&type=script&lang=js&"
export * from "./UiTab.vue?vue&type=script&lang=js&"
import style0 from "./UiTab.vue?vue&type=style&index=0&id=606c15ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c15ea",
  null
  
)

/* custom blocks */
import block0 from "./UiTab.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports